// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1YWzk","toggle":"style_toggle__1KTXy"};